var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueArroWup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4009",
    "data-name": "Rectangle 4009",
    width: 20,
    height: 20,
    transform: "translate(-11971 -3039)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Blue_Arrow_up",
    "data-name": "Blue Arrow up",
    transform: "translate(-11951 -3019) rotate(180)",
    clipPath: "url(#clip-path)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8258",
    "data-name": "Path 8258",
    d: "M0,0,5.414,5.414,0,10.827",
    transform: "translate(-11955.646 -3031.707) rotate(90)",
    fill: "none",
    stroke: "#0a64f9",
    strokeWidth: 2,
    style: {
      stroke: "#000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArroWup);
export default __webpack_public_path__ + "static/media/blueARROWup.ea7c8ec5c04aac72f142613649b86205.svg";
export { ForwardRef as ReactComponent };